<template>
  <div class="cssrs-epic" id="clinro-c-ssr-form">
    <table style="width: 100%;">
      <div v-for="(rows, customRowIndex) in activityQuestions" :key="customRowIndex">
        <div v-if="customRowIndex === 0">
          <SSRSBaseline :instructionScreen="rows[0]" :lang="lang" />
        </div>
        <div row v-if="customRowIndex === 1" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div class="col-row pl-15 border-bottom border-black bg-light">
            <span
              v-translate:_formattedTitle="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedTitle
              }"
              v-html="rows[0].formattedTitle"
            ></span>
          </div>
          <div class="col-row border-black">
            <b-col md="8" class="border-right border-black col-size-1">
              <span
                v-translate:_formattedInformation="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedInformation
                }"
                v-html="rows[0].formattedInformation"
              >
              </span>
            </b-col>
            <b-col
              md="2"
              class="border-right border-black col-size-2 p-0"
              v-translate:_lifetime="{
                key: rows[0].id,
                val: lang,
                html: suicidalIdeationIn
              }"
            >
              <p class="table-heading">
                <span class="d-block">Lifetime: Time </span>
                <span class="d-block">He/She Felt</span>
                <span class="d-block">Most Suicidal</span>
              </p>
            </b-col>
            <b-col md="2" class="border-right border-black pt-10 pb-10 bg-light col-size-3">
              <p class="table-heading text-center">
                <span
                  v-translate:_past="{
                    key: rows[0].id,
                    val: lang,
                    html: 'Past'
                  }"
                  >Past</span
                >
                {{ pastMothsSuicidalIdeation() }}
                <span
                  class="d-block"
                  v-translate:_month="{
                    key: rows[0].id,
                    val: lang,
                    html: 'Months'
                  }"
                  >Months</span
                >
              </p>
            </b-col>
          </div>
        </div>
        <div row v-if="customRowIndex === 2" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div class="col-row">
            <b-col md="8" class="border-right border-black col-size-1">
              <div
                v-translate:_formattedBody="{
                  key: rows[1].id,
                  val: lang,
                  html: rows[1].formattedBody
                }"
                v-html="rows[1].formattedBody"
              ></div>
              <!-- :class="{'disabled' : isWishToBeDead }" -->
              <div v-if="rows[0]" class="d-flex align-items-center">
                <span
                  class="text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                >
                </span>
                <!-- :disabled="isWishToBeDead" -->
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" maxlength="500" />
              </div>
            </b-col>

            <b-col md="2" class="border-right border-black pt-25 pb-25 pl-35 pr-45 col-md-1 col-size-2">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[1].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[1].options[0].formattedBody"
                  >
                  </label>
                  <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[1][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[0].id" />
                </div>
                <div class="no">
                  <label
                    class="d-block checkbox-label"
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[1].options[1].formattedBody
                    }"
                    v-html="rows[1].options[1].formattedBody"
                  >
                  </label>
                  <input type="checkbox" class="radio" name="fooby[1][]" :value="rows[1].options[1].id" @input="OnBooleanValueChange(rows[1], $event)" :checked="rows[1].answerId === rows[1].options[1].id" @click="onCheckboxClick(rows[1], $event)" />
                </div>
              </div>
            </b-col>

            <b-col md="2" class="border-right border-black pt-25 pb-25 pl-30 pr-20  col-md-1 bg-light col-size-3">
              <!-- :class="{'disabled' : isWishToBeDead}" -->
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    class="d-block checkbox-label"
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[2].options[0].formattedBody
                    }"
                    v-html="rows[2].options[0].formattedBody"
                  >
                  </label>
                  <input type="checkbox" class="radio" :value="rows[2].options[0].id" name="fooby[2][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[0].id" />
                  <!-- :disabled="isWishToBeDead" -->
                </div>
                <div class="no">
                  <label
                    class="d-block checkbox-label"
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[2].options[1].formattedBody
                    }"
                    v-html="rows[2].options[1].formattedBody"
                  >
                  </label>
                  <input type="checkbox" class="radio" :value="rows[2].options[1].id" name="fooby[2][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[1].id" />
                </div>
                <!-- :disabled="isWishToBeDead" -->
              </div>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 3" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="8" class="border-right border-black col-size-1">
            <div v-if="rows[1]" class="d-flex  flex-column">
              <div
                v-translate:_formattedBody="{
                  key: rows[1].id,
                  val: lang,
                  html: rows[1].formattedBody
                }"
                v-html="rows[1].formattedBody"
              ></div>
              <div class="align-items-center d-flex">
                <!-- :class="{'disabled' : isNonSpecific }" -->
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" maxlength="500" />
                <!-- :disabled="isNonSpecific" -->
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-35 pr-45 col-md-1 col-size-2">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[3][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[3][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" />
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-30 pr-20   col-md-1 bg-light col-size-3">
            <!-- :class="{'disabled' : isNonSpecific}" -->
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[2].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[2].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[0].id" name="fooby[4][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[0].id" />
                <!-- :disabled="isNonSpecific" -->
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[2].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[2].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[1].id" name="fooby[4][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[1].id" />
                <!-- :disabled="isNonSpecific" -->
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 4" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col :class="{ disabled: isSuicidalIdeation }" md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div v-if="rows[0]" class="d-flex  flex-column">
              <div class="align-items-center d-flex">
                <!-- :class="{'disabled' : isActivNoPlan}" -->
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" maxlength="500" />
                <!-- :disabled="isActivNoPlan" -->
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-35 pr-45 col-md-1 col-size-2">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[5][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isSuicidalIdeation" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[5][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isSuicidalIdeation" />
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-30 pr-20   col-md-1 bg-light col-size-3">
            <!-- :class="{'disabled' : isActivNoPlan}" -->
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[0].id" name="fooby[6][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[0].id" />
                <!-- :disabled="isActivNoPlan" -->
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[1].id" name="fooby[6][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[1].id" />
                <!-- :disabled="isActivNoPlan" -->
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 5" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col :class="{ disabled: isSuicidalIdeation }" md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div v-if="rows[0]" class="d-flex  flex-column">
              <div class="align-items-center d-flex">
                <!-- :class="{'disabled' : isSpecificPlan}" -->
                <span
                  class="qu-text-normal text-nowrap "
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></span>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" rows="6" maxlength="500" />
                <!-- :disabled="isSpecificPlan" -->
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-35 pr-45 col-md-1 col-size-2">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[7][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isSuicidalIdeation" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[7][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isSuicidalIdeation" />
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-30 pr-20   col-md-1 bg-light col-size-3">
            <!-- :class="{'disabled' : isSpecificPlan}" -->
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[2].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[2].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[0].id" name="fooby[8][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[0].id" />
                <!-- :disabled="isSpecificPlan" -->
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[2].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[2].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[1].id" name="fooby[8][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[1].id" />
                <!-- :disabled="isSpecificPlan" -->
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 6" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-bottom-0 border-black">
          <b-col md="8" :class="{ disabled: isSuicidalIdeation }" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
            ></div>
            <div class="d-flex  flex-column">
              <div class="align-items-center d-flex">
                <!-- :class="{'disabled' : isPlanAndIntent}" -->
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" maxlength="500" v-model="rows[0].answer" @input="onAnswerChange(rows[0])" />
                <!-- :disabled="isPlanAndIntent" -->
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-35 pr-45 col-md-1 col-size-2">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[9][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isSuicidalIdeation" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[9][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isSuicidalIdeation" />
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pt-25 pb-25 pl-30 pr-20    col-md-1 bg-light col-size-3">
            <!-- :class="{'disabled' : isPlanAndIntent}" -->
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[2].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[2].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[0].id" name="fooby[10][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[0].id" />
              </div>
              <!-- :disabled="isPlanAndIntent" -->
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[2].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[2].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[2].options[1].id" name="fooby[10][]" @input="OnBooleanValueChange(rows[2], $event)" @click="onCheckboxClick" :checked="rows[2].answerId === rows[2].options[1].id" />
              </div>
              <!-- :disabled="isPlanAndIntent" -->
            </div>
          </b-col>
        </div>
        <div row v-if="customRowIndex === 7" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black" :class="{ disabled: intensityOfIdeationSection }">
          <div class="pl-15 border-bottom border-black bg-light">
            <span
              v-translate:_formattedTitle="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedTitle
              }"
              v-html="rows[0].formattedTitle"
            ></span>
          </div>
          <div class="col-row">
            <b-col md="8" class="border-right border-black col-size-1">
              <span
                v-translate:_formattedInformation="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedInformation
                }"
                v-html="rows[0].formattedInformation"
              ></span>
            </b-col>
            <b-col md="1" class="border-right border-black col-md-1 col-size-2"> </b-col>
            <b-col md="1" class="border-right border-black col-md-1 bg-light col-size-3"> </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 8" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border-top-0 border border-bottom-0 border-black" :class="{ disabled: intensityOfIdeationSection }">
          <div class="col-row">
            <b-col md="8" class="border-right border-black col-size-1">
              <div class="col-sm th-ssrc-number-input col-align text-nowrap pl-0">
                <span
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></span>
                <div class="pl-10 type_block" style="    line-height: 4px;">
                  <div class="mb-3 ml-10 text-center">
                    {{ rows[0].answer }}
                    <input type="text" placeholder=" " class="ml-10 input_box" disabled="" />
                  </div>
                  <div
                    class="small-text  border-top pt-6"
                    v-translate:_type="{
                      key: rows[0].id,
                      val: lang,
                      html: 'Type # (1-5)'
                    }"
                  >
                    <span>Type # (1-5)</span>
                  </div>
                </div>
                <div class="sscr-most-severe-text-res" :class="lang == 'pl' ? 'description-polish-lang' : 'description-common-lang'">
                  <span class="pl-6 qu-text-normal"> {{ rows[1].answer }}</span>
                  <span
                    v-translate:_formattedBody="{
                      key: rows[1].id,
                      val: lang,
                      html: rows[1].formattedBody
                    }"
                    v-html="rows[1].formattedBody"
                  ></span>
                </div>
              </div>

              <div class="col-sm th-ssrc-number-input col-align text-nowrap pl-0">
                <span
                  v-translate:_formattedBody="{
                    key: rows[2].id,
                    val: lang,
                    html: rows[2].formattedBody
                  }"
                  v-html="rows[2].formattedBody"
                ></span>
                <div class="pl-10 type_block" style="line-height: 4px;">
                  <div class="mb-3 ml-10 text-center">
                    {{ rows[2].answer }}
                    <input type="text" placeholder=" " class="ml-10 input_box" disabled="" />
                  </div>
                  <div
                    class="small-text pt-6 border-top"
                    v-translate:_type="{
                      key: rows[2].id,
                      val: lang,
                      html: 'Type # (1-5)'
                    }"
                  >
                    <span>Type # (1-5)</span>
                  </div>
                </div>
                <div class="sscr-most-severe-text-res" :class="lang == 'pl' ? 'description-polish-lang' : 'description-common-lang'">
                  <span class="pl-6 qu-text-normal"> {{ rows[3].answer }}</span>
                  <span
                    v-translate:_formattedBody="{
                      key: rows[3].id,
                      val: lang,
                      html: rows[3].formattedBody
                    }"
                    v-html="rows[3].formattedBody"
                  ></span>
                </div>
              </div>
            </b-col>
            <b-col
              md="1"
              v-translate:_lifetime="{
                key: activityQuestions[7][0].id,
                val: lang,
                html: 'Most Severe'
              }"
              class="border-right border-black p-0 pt-0 pb-10 qu-text-normal text-center col-md-1 col-size-2"
            >
              Most Severe
            </b-col>
            <b-col
              md="1"
              style="margin-top: -10px !important;"
              class="border-right border-black qu-text-normal bg-light text-center col-md-1 col-size-3"
              :class="lang == 'pl' ? 'padding-polish' : 'padding-common'"
              v-translate:_recency="{
                key: activityQuestions[7][0].id,
                val: lang,
                html: mostSeverLabel
              }"
            >
              <span class="d-block"> Most </span>Severe
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 9" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border-bottom-0 border border-black" :class="{ disabled: intensityOfIdeationSection }">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-40 d-flex justify-content-center pb-10 col-md-1 col-size-2">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
          <b-col md="2" :class="{ disabled: isSuicidalIdeationRecency }" class="border-right border-black pt-40 pb-10 d-flex justify-content-center bg-light col-size-3">
            <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[1])" :disabled="isSuicidalIdeationRecency">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">
                {{ choice.formattedBody }}
              </option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 10" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black" :class="{ disabled: intensityOfIdeationSection }">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-40 d-flex justify-content-center pb-40 col-md-1 col-size-2">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
          <b-col md="2" :class="{ disabled: isSuicidalIdeationRecency }" class="border-right border-black pt-40 pb-40 d-flex justify-content-center bg-light col-md-1 col-size-3">
            <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[1])" :disabled="isSuicidalIdeationRecency">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 11" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black" :class="{ disabled: intensityOfIdeationSection }">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-40 d-flex justify-content-center pb-40 col-md-1 col-size-2">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
          <b-col md="2" :class="{ disabled: isSuicidalIdeationRecency }" class="border-right border-black pt-40 pb-40 d-flex justify-content-center bg-light col-md-1 col-size-3">
            <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[1])" :disabled="isSuicidalIdeationRecency">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 12" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black" :class="{ disabled: intensityOfIdeationSection }">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-60 d-flex justify-content-center col-md-1 col-size-2 deterrents-dropdown ">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
          <b-col md="2" :class="{ disabled: isSuicidalIdeationRecency }" class="border-right border-black pt-60 d-flex justify-content-center bg-light col-md-1 col-size-3 deterrents-dropdown">
            <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[1])" :disabled="isSuicidalIdeationRecency">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 13" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black" :class="{ disabled: intensityOfIdeationSection }">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-80 d-flex justify-content-center pb-80 col-md-1 col-size-2">
            <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[0])" :disabled="intensityOfIdeationSection">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
          <b-col md="2" :class="{ disabled: isSuicidalIdeationRecency }" class="border-right border-black pt-80 pb-80 d-flex justify-content-center bg-light col-md-1 col-size-3">
            <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box select-size" @change="onFieldChange(rows[1])" :disabled="isSuicidalIdeationRecency">
              <option key value>&nbsp;</option>
              <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
            </select>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 14" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-bottom-0 border-black">
          <div class="border-bottom border-black bg-light d-flex">
            <b-col md="8" class="border-right border-black col-size-1">
              <p
                v-translate:_formattedTitle="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedTitle
                }"
                class="p-header p-0"
              >
                SUICIDAL BEHAVIOR
              </p>
              <p
                v-translate:_formattedInformation="{
                  key: rows[0].id,
                  val: lang,
                  html: rows[0].formattedInformation
                }"
                class="instruction"
              >
                (Check all that apply, so long as these are separate events; must ask about all types)
              </p>
            </b-col>
            <b-col md="2" class="border-right border-black col-md-1 col-size-2 pl-5 pr-5">
              <p
                v-translate:_lifetime="{
                  key: rows[0].id,
                  val: lang,
                  html: 'Lifetime'
                }"
                style="    height: 100%;"
                class="table-heading pt-0 d-flex justify-content-center align-items-center"
              >
                Lifetime
              </p>
            </b-col>
            <b-col md="2" class="border-right border-black bg-light col-md-1 col-size-3 d-flex flex-column justify-content-center align-items-center">
              <p class="table-heading text-center ">
                <span
                  v-translate:_past="{
                    key: activityQuestions[1][0].id,
                    val: lang,
                    html: 'Past'
                  }"
                  >Past</span
                >
                {{ pastMothsSuicidalBehavior() }}
                <span
                  class="d-block"
                  v-translate:_month="{
                    key: activityQuestions[1][0].id,
                    val: lang,
                    html: 'Months'
                  }"
                  >Months</span
                >
              </p>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 15" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-column border border-top-0 border-bottom-0 border-black">
          <div class="col-row">
            <b-col md="8" class="border-right border-black col-size-1">
              <div>
                <span
                  v-translate:_formattedBody="{
                    key: rows[0].id,
                    val: lang,
                    html: rows[0].formattedBody
                  }"
                  v-html="rows[0].formattedBody"
                ></span>
              </div>
              <div class="align-items-center d-flex" :class="{ disabled: isSuicidalBehaviorActualAttepts }">
                <p
                  class="qu-text-normal text-nowrap"
                  v-translate:_formattedBody="{
                    key: rows[2].id,
                    val: lang,
                    html: rows[2].formattedBody
                  }"
                  v-html="rows[2].formattedBody"
                ></p>
                <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" v-model="rows[2].answer" maxlength="500" @input="onAnswerChange(rows[2])" :disabled="isSuicidalBehaviorActualAttepts" />
              </div>
            </b-col>
            <b-col md="2" class="border-right border-black pb-25 p-0 col-md-1 col-size-2 mediaclass">
              <div class="d-flex justify-content-between pl-35 pr-45">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[11][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[0].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[0].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[11][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
                </div>
              </div>
              <div style="padding-top: 10rem;" :class="{ disabled: isSuicidalBehaviorActualAttepts }">
                <span
                  v-translate:_formattedBody="{
                    key: rows[3].id,
                    val: lang,
                    html: rows[3].formattedBody
                  }"
                  v-html="rows[3].formattedBody"
                ></span>
                <div class="th-ssrc-number-input pl-45 pr-45">
                  <input :disabled="isSuicidalBehaviorActualAttepts" type="number" @input="onNumberValueChange(rows[3], $event)" v-model="rows[3].answer" placeholder=" " :max="999" :min="0" :maxlength="3" />
                </div>
              </div>
            </b-col>
            <b-col md="2" :class="{ disabled: isSuicidalBehaviorActualAttepts }" class="border-right border-black pb-25 p-0 col-md-1 col-size-3 bg-light">
              <div class="d-flex justify-content-between pl-30 pr-20">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[1].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[1].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[12][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isSuicidalBehaviorActualAttepts" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[1].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[1].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[12][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isSuicidalBehaviorActualAttepts" />
                </div>
              </div>
              <div style="padding-top: 10rem;" :class="{ disabled: isSuicidalBehaviorActualAtteptsRecency }">
                <span
                  v-translate:_formattedBody="{
                    key: rows[4].id,
                    val: lang,
                    html: rows[4].formattedBody
                  }"
                  v-html="rows[4].formattedBody"
                ></span>
                <div class="th-ssrc-number-input pl-30 pr-30">
                  <input style="background-color: inherit;" :disabled="isSuicidalBehaviorActualAtteptsRecency" @input="onNumberValueChange(rows[4], $event)" type="number" v-model="rows[4].answer" placeholder=" " max="999" maxlength="3" />
                </div>
              </div>
            </b-col>
          </div>

          <div class="col-row">
            <b-col md="8" class="border-right border-black col-size-1 d-flex align-items-end">
              <div
                class="pt-20"
                v-translate:_formattedBody="{
                  key: rows[5].id,
                  val: lang,
                  html: rows[5].formattedBody
                }"
                v-html="rows[5].formattedBody"
              ></div>
            </b-col>
            <b-col md="2" class="border-right border-black  pl-35 pr-45 col-md-1 col-size-2">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[5].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[5].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[5].options[0].id" name="fooby[13][]" @input="OnBooleanValueChange(rows[5], $event)" @click="onCheckboxClick" :checked="rows[5].answerId === rows[5].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[5].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[5].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[5].options[1].id" name="fooby[13][]" @input="OnBooleanValueChange(rows[5], $event)" @click="onCheckboxClick" :checked="rows[5].answerId === rows[5].options[1].id" />
                </div>
              </div>
            </b-col>
            <b-col md="2" class="border-right border-black pl-30 pr-20 col-md-1 col-size-3 bg-light">
              <div class="d-flex justify-content-between">
                <div class="yes">
                  <label
                    v-translate:_yes="{
                      key: 'rsb',
                      val: lang,
                      html: rows[6].options[0].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[6].options[0].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[6].options[0].id" name="fooby[14][]" @input="OnBooleanValueChange(rows[6], $event)" @click="onCheckboxClick" :checked="rows[6].answerId === rows[6].options[0].id" />
                </div>
                <div class="no">
                  <label
                    v-translate:_no="{
                      key: 'rsb',
                      val: lang,
                      html: rows[6].options[1].formattedBody
                    }"
                    class="d-block checkbox-label"
                    v-html="rows[6].options[1].formattedBody"
                  ></label>
                  <input type="checkbox" class="radio" :value="rows[6].options[1].id" name="fooby[14][]" @input="OnBooleanValueChange(rows[6], $event)" @click="onCheckboxClick" :checked="rows[6].answerId === rows[6].options[1].id" />
                </div>
              </div>
            </b-col>
          </div>
        </div>

        <div row v-if="customRowIndex === 16" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
            <div class="align-items-center d-flex" :class="{ disabled: isLifetimeInterruptedAttempt }">
              <p
                class="qu-text-normal text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[2].id,
                  val: lang,
                  html: rows[2].formattedBody
                }"
                v-html="rows[2].formattedBody"
              ></p>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" v-model="rows[2].answer" maxlength="500" @input="onAnswerChange(rows[2])" :disabled="isLifetimeInterruptedAttempt" />
            </div>
          </b-col>
          <b-col md="2" class="border-right border-black pb-10 p-0 col-md-1 col-size-2">
            <div class="d-flex justify-content-between pl-35 pr-45">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[15][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[15][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
            <div class="pt-55" :class="{ disabled: isLifetimeInterruptedAttempt }">
              <span
                v-translate:_formattedBody="{
                  key: rows[3].id,
                  val: lang,
                  html: rows[3].formattedBody
                }"
                v-html="rows[3].formattedBody"
              ></span>
              <div class="th-ssrc-number-input pl-45 pr-45">
                <input :disabled="isLifetimeInterruptedAttempt" type="number" v-model="rows[3].answer" @input="onNumberValueChange(rows[3], $event)" placeholder=" " max="999" maxlength="3" />
              </div>
            </div>
          </b-col>

          <b-col md="2" class="border-right border-black pb-10 p-0  col-md-1 col-size-3 bg-light" :class="{ disabled: isLifetimeInterruptedAttempt }">
            <div class="d-flex justify-content-between pl-30 pr-20">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[16][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isLifetimeInterruptedAttempt" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[16][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isLifetimeInterruptedAttempt" />
              </div>
            </div>
            <div class="pt-55" :class="{ disabled: isRecencyInterruptedAttempt }">
              <span
                v-translate:_formattedBody="{
                  key: rows[4].id,
                  val: lang,
                  html: rows[4].formattedBody
                }"
                v-html="rows[4].formattedBody"
              ></span>
              <div class="th-ssrc-number-input pl-30 pr-30">
                <input style="background: inherit;" @input="onNumberValueChange(rows[4], $event)" type="number" v-model="rows[4].answer" placeholder=" " :disabled="isRecencyInterruptedAttempt" max="999" maxlength="3" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 17" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
            <div class="align-items-center d-flex" :class="{ disabled: isAbortedAttempt }">
              <p
                class="qu-text-normal text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[2].id,
                  val: lang,
                  html: rows[2].formattedBody
                }"
                v-html="rows[2].formattedBody"
              ></p>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" v-model="rows[2].answer" maxlength="500" @input="onAnswerChange(rows[2])" :disabled="isAbortedAttempt" />
            </div>
          </b-col>
          <b-col md="1" class="border-right border-black pb-10 p-0 col-md-1 col-size-2">
            <div class="d-flex justify-content-between pl-35 pr-45">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[17][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[17][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
            <div class="pt-10" :class="{ disabled: isAbortedAttempt }">
              <span
                v-translate:_formattedBody="{
                  key: rows[3].id,
                  val: lang,
                  html: rows[3].formattedBody
                }"
                v-html="rows[3].formattedBody"
              ></span>
              <div class="th-ssrc-number-input pl-45 pr-45">
                <input type="number" :disabled="isAbortedAttempt" @input="onNumberValueChange(rows[3], $event)" v-model="rows[3].answer" placeholder=" " max="999" maxlength="3" />
              </div>
            </div>
          </b-col>
          <b-col md="1" :class="{ disabled: isAbortedAttempt }" class="border-right border-black pb-10 p-0 col-md-1 col-size-3 bg-light">
            <div class="d-flex justify-content-between pl-30 pr-20">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[002][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isAbortedAttempt" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[002][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isAbortedAttempt" />
              </div>
            </div>
            <div class="pt-10" :class="{ disabled: isRecencyAbortedAttempt }">
              <span
                v-translate:_formattedBody="{
                  key: rows[4].id,
                  val: lang,
                  html: rows[4].formattedBody
                }"
                v-html="rows[4].formattedBody"
              ></span>
              <div class="th-ssrc-number-input pl-30 pr-30">
                <input style="background: inherit;" type="number" @input="onNumberValueChange(rows[4], $event)" v-model="rows[4].answer" placeholder=" " :disabled="isRecencyAbortedAttempt" max="999" min="1" maxlength="3" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 18" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
            <div class="align-items-center d-flex" :class="{ disabled: isPreparatoryActs }">
              <p
                class="qu-text-normal text-nowrap"
                v-translate:_formattedBody="{
                  key: rows[2].id,
                  val: lang,
                  html: rows[2].formattedBody
                }"
                v-html="rows[2].formattedBody"
              ></p>
              <b-form-textarea class="mb-0 ml-5 mr-15 activity-Form-Text" type="text" name="activityFormTextPreview" rows="6" maxlength="500" v-model="rows[2].answer" @input="onAnswerChange(rows[2])" :disabled="isPreparatoryActs" />
            </div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-20 pb-25  pl-35 pr-45 col-md-1 col-size-2">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[19][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[19][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
          </b-col>

          <b-col md="2" :class="{ disabled: isPreparatoryActs }" class="pt-20 border-right border-black pb-25 pl-30 pr-20 col-md-1 col-size-3 bg-light">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[20][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isPreparatoryActs" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[20][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isPreparatoryActs" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 19" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black">
          <b-col md="8" class="border-right border-black col-size-1">
            <div
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></div>
          </b-col>
          <b-col md="2" class="border-right border-black pt-5 pb-5 p-0 col-md-1 col-size-2">
            <div class="d-flex justify-content-between pl-35 pr-45">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[0].id" name="fooby[201][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[0].id" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[0].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[0].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[0].options[1].id" name="fooby[201][]" @input="OnBooleanValueChange(rows[0], $event)" @click="onCheckboxClick" :checked="rows[0].answerId === rows[0].options[1].id" />
              </div>
            </div>
          </b-col>

          <b-col md="2" :class="{ disabled: isLifeTimeSuicidalBehavior }" class="border-right border-black pt-5 pb-5 pl-30 pr-20 col-md-1 col-size-3 bg-light">
            <div class="d-flex justify-content-between">
              <div class="yes">
                <label
                  v-translate:_yes="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[0].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[0].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[0].id" name="fooby[001][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[0].id" :disabled="isLifeTimeSuicidalBehavior" />
              </div>
              <div class="no">
                <label
                  v-translate:_no="{
                    key: 'rsb',
                    val: lang,
                    html: rows[1].options[1].formattedBody
                  }"
                  class="d-block checkbox-label"
                  v-html="rows[1].options[1].formattedBody"
                ></label>
                <input type="checkbox" class="radio" :value="rows[1].options[1].id" name="fooby[001][]" @input="OnBooleanValueChange(rows[1], $event)" @click="onCheckboxClick" :checked="rows[1].answerId === rows[1].options[1].id" :disabled="isLifeTimeSuicidalBehavior" />
              </div>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 20" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex border-bottom-0 flex-row border border-black bg-light text-line-height" :class="{ disabled: isSuicidalBehaviorActualAttepts }">
          <b-col md="8" class="border-right text-dark border-black col-size-5">
            <span
              v-translate:_formattedInformation="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedInformation
              }"
              v-html="rows[0].formattedInformation"
            ></span>
          </b-col>
          <b-col md="1" class="border-right border-black col-size-9 pl-5 pr-1">
            <span
              v-translate:_formattedBody="{
                key: rows[1].id,
                val: lang,
                html: rows[1].formattedBody
              }"
              v-html="rows[1].formattedBody"
              class="d-font"
            ></span>
            <div class="cssr-baseline-select-date">
              <span
                class="d-font"
                v-translate:_date="{
                  key: rows[1].id,
                  val: lang,
                  html: 'Date:'
                }"
                >Date:</span
              >
              <datepicker :disabled="isSuicidalBehaviorActualAttepts" input-class="inner-card-date-value pt-2 pb-2 p-0" placeholder=" " v-model="rows[1].date" @input="onDateChange(rows[1])" format="dd/MMM/yyyy" name="startDate" :disabled-dates="disabledDates" :key="`${rows[1].id} + a`"></datepicker>
            </div>
          </b-col>
          <b-col md="1" class="border-right border-black col-size-9 pl-5 pr-1">
            <span class="date-text-wrap">
              <span
                v-translate:_formattedBody="{
                  key: rows[2].id,
                  val: lang,
                  html: rows[2].formattedBody
                }"
                v-html="rows[2].formattedBody"
                class="d-font"
              ></span>
            </span>
            <div class="cssr-baseline-select-date">
              <span
                class="d-font"
                v-translate:_date="{
                  key: rows[1].id,
                  val: lang,
                  html: 'Date:'
                }"
                >Date:</span
              >
              <datepicker :disabled="isSuicidalBehaviorActualAttepts" input-class="inner-card-date-value pt-2 pb-2 p-0" v-model="rows[2].date" format="dd/MMM/yyyy" @input="onDateChange(rows[2])" name="startDate1" :disabled-dates="disabledDates" :key="`${rows[2].id} + a`"></datepicker>
            </div>
          </b-col>
          <b-col md="1" class="border-right border-black col-size-9 pl-5 pr-1">
            <span
              v-translate:_formattedBody="{
                key: rows[3].id,
                val: lang,
                html: rows[3].formattedBody
              }"
              v-html="rows[3].formattedBody"
              class="d-font"
            ></span>
            <div class="cssr-baseline-select-date">
              <span
                class=" d-font"
                v-translate:_date="{
                  key: rows[1].id,
                  val: lang,
                  html: 'Date:'
                }"
                >Date:</span
              >
              <datepicker :disabled="isSuicidalBehaviorActualAttepts" input-class="inner-card-date-value pt-2 pb-2 p-0" v-model="rows[3].date" format="dd/MMM/yyyy" @input="onDateChange(rows[3])" name="startDate" :disabled-dates="disabledDates" :key="`${rows[3].id} + a`"></datepicker>
            </div>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 21" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border-bottom-0 border border-black" :class="{ disabled: isSuicidalBehaviorActualAttepts }">
          <b-col md="8" class="border-right border-black col-size-5">
            <span
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></span>
          </b-col>
          <b-col md="1" class="border-right border-black text-center col-size-9 ">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box mt-75" @change="onFieldChange(rows[0])" style="width:auto" :disabled="isSuicidalBehaviorActualAttepts">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
              </select>
            </span>
          </b-col>
          <b-col md="1" class="border-right border-black text-center col-size-9 ">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box mt-75" @change="onFieldChange(rows[1])" style="width:auto" :disabled="isSuicidalBehaviorActualAttepts">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
              </select>
            </span>
          </b-col>
          <b-col md="1" class="border-right border-black text-center col-size-9 ">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[2].answer" size="sm" class="form-control input-md custom-number-select-box mt-75" @change="onFieldChange(rows[2])" style="width:auto" :disabled="isSuicidalBehaviorActualAttepts">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[2].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
              </select>
            </span>
          </b-col>
        </div>

        <div row v-if="customRowIndex === 22" class="th-activity-edc-form-preview activty-demo pr-0 col-row d-flex flex-row border border-black">
          <b-col md="8" :class="{ disabled: isSuicidalBehaviorActualAttepts }" class="border-right border-black col-size-5">
            <span
              v-translate:_formattedBody="{
                key: rows[0].id,
                val: lang,
                html: rows[0].formattedBody
              }"
              v-html="rows[0].formattedBody"
            ></span>
          </b-col>
          <b-col md="1" :class="{ disabled: isMostRecentAttempt }" class="border-right border-black text-center col-size-9 ">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[0].answer" size="sm" class="form-control input-md custom-number-select-box mt-55" @change="onFieldChange(rows[0])" :disabled="isSuicidalBehaviorActualAttepts || isMostRecentAttempt">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[0].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
              </select>
            </span>
          </b-col>
          <b-col md="1" :class="{ disabled: isMostLethalAttempt }" class="border-right border-black text-center col-size-9 ">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[1].answer" size="sm" class="form-control input-md custom-number-select-box mt-55" @change="onFieldChange(rows[1])" :disabled="isSuicidalBehaviorActualAttepts || isMostLethalAttempt">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[1].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
              </select>
            </span>
          </b-col>
          <b-col md="1" :class="{ disabled: isMostFirstAttempt }" class="border-right border-black text-center col-size-9 ">
            <span
              v-translate:_code="{
                key: 'enter',
                val: lang,
                html: enterCodeLabel
              }"
              class="instruction"
              v-html="enterCodeLabel"
            ></span>
            <span class="d-flex justify-content-center">
              <select v-model="rows[2].answer" size="sm" class="form-control input-md custom-number-select-box mt-55" @change="onFieldChange(rows[2])" :disabled="isSuicidalBehaviorActualAttepts || isMostFirstAttempt">
                <option key value>&nbsp;</option>
                <option v-for="choice in rows[2].options" :key="choice.id" :value="choice.body">{{ choice.formattedBody }}</option>
              </select>
            </span>
          </b-col>
        </div>
      </div>
    </table>
  </div>
</template>

<script>
import baseline from "./baseline.json";
import * as clinRoService from "@/components/services/custom-clinro-branching";
import "@/components/activity-form/activity-form-custom-clinro/sccr.scss";
import SSRSBaseline from "./c-ssrs-baseline-history";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "lodash";
import $ from "jquery";

const { WISH_TO_BE_DEAD_BASELINE, NON_SPECIFIC_ACTIVE_BASELINE, ACTIVE_SUICIDAL_NO_PLAN_BASELINE, INTENT_TO_ACT_BASELINE, ACTIVE_SUICIDAL_SPECIFIC_PLAN_BASELINE, ACTUAL_ATTEMPT_BASELINE, ACTUAL_ATTEMPT_DATE_BASELINE, FREQUENCY, MOST_SERVERE_IDEATION, DUARATION, CONTROLLABILTY, DETERRENTS, REASONS_FOR_IDEATION, ACTUAL_LETHALITY_BASELINE, POTENTIAL_LETHALITY_BSELINE } = clinRoService;
export default {
  components: {
    SSRSBaseline,
    Datepicker
  },
  props: {
    activityFormData: {},
    mode: {
      default: 0
    },
    queryIds: null,
    selectedId: null,
    studyId: {
      type: String
    },
    lang: {
      type: String,
      default: "EN"
    }
  },
  methods: {
    pastMothsSuicidalIdeation() {
      return this.studyId == "6203226b-4d95-487d-ade3-28b3ae47e10f" || // prod test
      this.studyId == "96c73417-c29e-4825-9261-49659c0ff83c" || //UAT
      this.studyId == "1ae382c1-9ecc-4f69-89f4-b90c044a1e2a" ||
      this.studyId == "1834bdb3-6f51-4f00-b09c-9ba1d3e93d29" || //stage
      this.studyId == "20dda5b7-6bf8-4f82-aa1b-50aad4ec89b7" ||
      this.studyId == "bc382c49-9ff6-482a-af97-59e378e88f17" || // prod client
      this.studyId == "d29d00cb-8eaa-4b56-a3c6-3cc8b39464a8" || // DEV (For Testing of TUR-136860)
      this.studyId == "ba9cee09-80ff-4c8d-b610-3f527f2c8f05" || // STAGE (For Testing of TUR-136860)
      this.studyId == "fd41b75a-9698-4760-9e28-dca7cefbc109" || // UAT (For Testing of TUR-136860)
      this.studyId == "53c9ef1f-bdf7-456f-a0f8-553bf33b2a6e" ||
      this.studyId == "12a09a9d-40c6-4e15-b779-3db8b603c33d" || // PROD CLIENT: ICON-SANOFI [ID: 654154] (TUR-136860)
      this.studyId == "a09b7073-a2f4-4ea6-afd4-bb3ede441d16" || // PROD CLIENT: UBC [ID: 654166] (TUR-140464)
      this.studyId == "9a29876b-365a-4bd3-a0d0-bdf05a5c042c" || // DEV (For Testing of TUR-155332)
      this.studyId == "5ee53d4a-dab3-4510-aca3-0f2e3cd31773" || // STAGE (For Testing of TUR-155332)
      this.studyId == "e16bb221-be6b-454e-a3b5-4f845242589a" || // UAT (For Testing of TUR-155332)
      this.studyId == "7c806f78-0b96-49c1-a392-6afe918c8412" || // Sanofi Instance (For HS Obtain of TUR-155332)
        this.studyId == "b6ef452a-9d2d-4ebc-8c3a-53246973c4b1" // Sanofi-UAT Instance (For Mock Study of TUR-155332)
        ? 6
        : 6;
    },
    pastMothsSuicidalBehavior() {
      return this.studyId == "6203226b-4d95-487d-ade3-28b3ae47e10f" || // prod tests
      this.studyId == "96c73417-c29e-4825-9261-49659c0ff83c" || //UAT
      this.studyId == "1ae382c1-9ecc-4f69-89f4-b90c044a1e2a" ||
      this.studyId == "1834bdb3-6f51-4f00-b09c-9ba1d3e93d29" || //stage
      this.studyId == "20dda5b7-6bf8-4f82-aa1b-50aad4ec89b7" ||
      this.studyId == "bc382c49-9ff6-482a-af97-59e378e88f17" || // prod client
      this.studyId == "d29d00cb-8eaa-4b56-a3c6-3cc8b39464a8" || // DEV (For Testing of TUR-136860)
      this.studyId == "ba9cee09-80ff-4c8d-b610-3f527f2c8f05" || // STAGE (For Testing of TUR-136860)
      this.studyId == "fd41b75a-9698-4760-9e28-dca7cefbc109" || // UAT (For Testing of TUR-136860)
      this.studyId == "53c9ef1f-bdf7-456f-a0f8-553bf33b2a6e" ||
      this.studyId == "12a09a9d-40c6-4e15-b779-3db8b603c33d" || // PROD CLIENT: ICON-SANOFI [ID: 654154] (TUR-136860)
      this.studyId == "a09b7073-a2f4-4ea6-afd4-bb3ede441d16" || // PROD CLIENT: UBC [ID: 654166] (TUR-140464)
      this.studyId == "a7b534e4-1988-4e6f-86e3-3ada40dfb06a" || // DEV (For Testing of TUR-155332)
      this.studyId == "5ee53d4a-dab3-4510-aca3-0f2e3cd31773" || // STAGE (For Testing of TUR-155332)
      this.studyId == "e16bb221-be6b-454e-a3b5-4f845242589a" || // UAT (For Testing of TUR-155332)
      this.studyId == "7c806f78-0b96-49c1-a392-6afe918c8412" || // Sanofi Instance (For HS Obtain of TUR-155332)
        this.studyId == "b6ef452a-9d2d-4ebc-8c3a-53246973c4b1" // Sanofi-UAT Instance (For Mock Study of TUR-155332)
        ? 6
        : 12;
    },
    clearAnswer(question) {
      if (question.answerId) {
        question.answerId = undefined;
      }
      if (question.answer) {
        question.answer = "";
      }
      if (question.date) {
        question.date = "";
      }
      this.onMostSevereIdeationChange(question);
    },
    OnBooleanValueChange(data, event) {
      if (event && event.target && !event.target.checked) {
        data.answerId = "";
        data.answer = "";
      } else {
        data.answerId = event.target.value;
      }
      this.onAnswerChange(data);
    },
    onNumberValueChange(question, event) {
      event.target.value = event.target.value.replace(/[^0-9]+/g, "");
      const regExWholeNumber = "-?[0-9]+?";
      const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);
      if (!regExpWholeNumber.test(Number(question.answer))) {
        question.answer = question.answer.replace(".", "");
        this.$toastr.error("Decimals are not allowed.");
      } else if (Number(question.answer) > 999 || question.answer.length > 3) {
        question.answer = question.answer.substring(0, 3);
        this.$toastr.error("Total must be an integer with max of 3 digits.");
      } else if (question.answer < 0) {
        question.answer = null;
        this.$toastr.error("Negative value not allowed.");
      }
      this.onAnswerChange(question);
    },
    onDateChange(step) {
      const actualAttemptsDate = this.activityQuestions[ACTUAL_ATTEMPT_DATE_BASELINE];
      const mostRecentAttempt = actualAttemptsDate[1].date;
      const mostLethalAttempt = actualAttemptsDate[2].date;
      const initialFirstAttempt = actualAttemptsDate[3].date;

      const mostRecentAttemptDate = moment(mostRecentAttempt);
      const mostLethalAttemptDate = moment(mostLethalAttempt);
      const initialFirstAttemptDate = moment(initialFirstAttempt);

      if (mostLethalAttempt && mostLethalAttemptDate.diff(step.date) > 0 && step.body === "most_recent_attempt_date") {
        this.$nextTick(() => (step.date = null));
        this.$toastr.error("Most Recent Attempt Date field must be greater or equal to the Most Lethal Attempt Date.");
        return;
      }
      if (initialFirstAttempt && initialFirstAttemptDate.diff(step.date) > 0 && step.body === "most_recent_attempt_date") {
        this.$nextTick(() => (step.date = null));
        this.$toastr.error("Most Recent Attempt Date field must be greater or equal to the Initial/First Attempt Date.");
        return;
      }
      if (mostLethalAttempt && mostLethalAttemptDate.diff(step.date) < 0 && step.body === "initial_or_first_attempt_date") {
        this.$nextTick(() => (step.date = null));
        this.$toastr.error("Initial/First Attempt Date field must be less than or equal to the Most Lethal Attempt Date.");
        return;
      }
      if (step.date && mostRecentAttempt) {
        if (mostRecentAttemptDate.diff(step.date) < 0 && step.body === "most_lethal_attempt_date") {
          this.$nextTick(() => (step.date = null));
          this.$toastr.error("Most Lethal Attempt Date field must be less than or equal to the Most Recent Attempt Date.");
        } else if (mostRecentAttemptDate.diff(step.date) < 0 && step.body === "initial_or_first_attempt_date") {
          this.$nextTick(() => (step.date = null));
          this.$toastr.error("Initial/First Attempt Date field must be less than or equal to the Most Recent Attempt Date.");
        } else if (mostLethalAttempt && mostLethalAttemptDate.diff(step.date) < 0 && step.body === "initial_or_first_attempt_date") {
          this.$nextTick(() => (step.date = null));
          this.$toastr.error("Initial/First Attempt Date field must be less than or equal to the Most Lethal Attempt Date.");
        } else {
          this.onAnswerChange(step);
        }
      }
      if (initialFirstAttempt && initialFirstAttemptDate.diff(step.date) > 0 && step.body === "most_lethal_attempt_date") {
        this.$nextTick(() => (step.date = null));
        this.$toastr.error("Most Lethal Attempt Date field must be greater or equal to the Initial/First Attempt Date.");
      } else {
        this.onAnswerChange(step);
      }
    },
    onFieldChange(componentData) {
      if (componentData && componentData.type == "DropDown" && componentData.answer == "") {
        componentData.answerId = "";
      }
      this.$nextTick(() => {
        for (let i = 0; i < componentData.options.length; i++) {
          const option = componentData.options[i];
          if (option.body == componentData.answer) {
            componentData.optionId = option.id;
            componentData.index = i;
          }
        }
        this.onAnswerChange(componentData);
      });
    },
    select(id) {
      if (this.queryIds && this.queryIds.includes(id) && this.hasQueryCreated(id) && this.hasQueryCreated(id).length) {
        this.$emit("selected", id);
      }
    },
    scrollToId() {
      if (this.selectedId) {
        window.document.getElementById(`${this.selectedId}`).scrollIntoViewIfNeeded(true);
      }
    },
    setErrorFieldsOnEachStep() {
      this.activityFormData.activity.questions.forEach(step => {
        this.$set(step, "hasFieldError", false);
        this.$set(step, "fieldErrorText", "");
      });
    },
    onCheckboxClick() {
      $("input:checkbox").on("click", function() {
        const $box = $(this);
        if ($box.is(":checked")) {
          const group = "input:checkbox[name='" + $box.attr("name") + "']";
          $(group).prop("checked", false);
          $box.prop("checked", true);
        } else {
          $box.prop("checked", false);
        }
      });
    },
    //
    onCheckBoxClick() {
      const $box = $(this);
      if ($box.is(":checked")) {
        const group = "input:checkbox[name='" + $box.attr("name") + "']";
        $(group).prop("checked", false);
        $box.prop("checked", true);
      } else {
        $box.prop("checked", false);
      }
    },
    onAnswerChange(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;

      const mostSevereIdeation = this.getMostSevereIdeation();
      const mostSevereIdeationRecency = this.getMostSevereIdeationOfRecency();
      const showValues = this.activityQuestions[MOST_SERVERE_IDEATION];
      if (showValues) {
        if (showValues[0]) {
          showValues[0].answer = mostSevereIdeation.type;
          this.onMostSevereIdeationChange(showValues[0]);
        }
        if (showValues[2]) {
          showValues[2].answer = mostSevereIdeationRecency.type;
          this.onMostSevereIdeationChange(showValues[2]);
        }
        if (showValues[1]) {
          showValues[1].answer = mostSevereIdeation.description;
          this.onMostSevereIdeationChange(showValues[1]);
        }
        if (showValues[3]) {
          showValues[3].answer = mostSevereIdeationRecency.description;
          this.onMostSevereIdeationChange(showValues[3]);
        }
      }
    },
    onMostSevereIdeationChange(step) {
      const selectedStepIndex = this.activityFormData.activity.questions.findIndex(o => o.id == step.id);
      this.activityFormData.activity.questions[selectedStepIndex] = step;
    },
    clearSuicidalIdeationAnswer() {
      const activeSuicidalIdeationWithPlan = this.activityQuestions[ACTIVE_SUICIDAL_NO_PLAN_BASELINE];
      const activeSuicidalIdeationWithoutPlan = this.activityQuestions[INTENT_TO_ACT_BASELINE];
      const activeSpecificPlan = this.activityQuestions[ACTIVE_SUICIDAL_SPECIFIC_PLAN_BASELINE];
      this.clearAnswer(activeSuicidalIdeationWithPlan[0]);
      this.clearAnswer(activeSuicidalIdeationWithPlan[1]);
      this.clearAnswer(activeSuicidalIdeationWithPlan[2]);

      this.clearAnswer(activeSuicidalIdeationWithoutPlan[0]);
      this.clearAnswer(activeSuicidalIdeationWithoutPlan[1]);
      this.clearAnswer(activeSuicidalIdeationWithoutPlan[2]);

      this.clearAnswer(activeSpecificPlan[0]);
      this.clearAnswer(activeSpecificPlan[1]);
      this.clearAnswer(activeSpecificPlan[2]);
    },
    onClearIntensityOfIdeationSectionAnswer() {
      // 6
      const mostSevereIdeationType = this.activityQuestions[MOST_SERVERE_IDEATION];
      const isFrequency = this.activityQuestions[FREQUENCY];
      const isDuration = this.activityQuestions[DUARATION];
      const isControllability = this.activityQuestions[CONTROLLABILTY];
      const isDeterrents = this.activityQuestions[DETERRENTS];
      const isReasonsforIdeation = this.activityQuestions[REASONS_FOR_IDEATION];
      if (this.intensityOfIdeationSection) {
        this.clearAnswer(mostSevereIdeationType[0]);
        this.clearAnswer(isFrequency[0]);
        this.clearAnswer(isDuration[0]);
        this.clearAnswer(isControllability[0]);
        this.clearAnswer(isDeterrents[0]);
        this.clearAnswer(isReasonsforIdeation[0]);
      }
      if (this.isSuicidalIdeationRecency) {
        this.clearAnswer(mostSevereIdeationType[1]);
        this.clearAnswer(isFrequency[1]);
        this.clearAnswer(isDuration[1]);
        this.clearAnswer(isControllability[1]);
        this.clearAnswer(isDeterrents[1]);
        this.clearAnswer(isReasonsforIdeation[1]);
      }
    },
    onClearSuicidalBehavior() {
      const question = this.activityQuestions[ACTUAL_ATTEMPT_BASELINE];
      const actualAtteptsQuestion = this.activityQuestions[ACTUAL_ATTEMPT_DATE_BASELINE];
      const medicalDamageQuestion = this.activityQuestions[ACTUAL_LETHALITY_BASELINE];
      const potentialLethalityQuestion = this.activityQuestions[POTENTIAL_LETHALITY_BSELINE];
      if (this.isSuicidalBehaviorActualAttepts) {
        this.clearAnswer(question[1]);
        this.clearAnswer(question[2]);
        this.clearAnswer(question[3]);
        //Date
        this.clearAnswer(actualAtteptsQuestion[1]);
        this.clearAnswer(actualAtteptsQuestion[2]);
        this.clearAnswer(actualAtteptsQuestion[3]);
        // Actual Lethality/Medical Damage
        this.clearAnswer(medicalDamageQuestion[0]);
        this.clearAnswer(medicalDamageQuestion[1]);
        this.clearAnswer(medicalDamageQuestion[2]);
        // Potential Lethality
        this.clearAnswer(potentialLethalityQuestion[0]);
        this.clearAnswer(potentialLethalityQuestion[1]);
        this.clearAnswer(potentialLethalityQuestion[2]);
      }
      if (this.isSuicidalBehaviorActualAtteptsRecency) {
        this.clearAnswer(question[4]);
      }
    },
    getMostSevereIdeation() {
      const { isWishToBeDead, isNonSpecific, isActivNoPlan, isSpecificPlan, isPlanAndIntent } = this;
      const mostSevereIdeation = {
        type: null,
        description: null
      };
      if (!isPlanAndIntent) {
        mostSevereIdeation.type = 5;
        mostSevereIdeation.description = "Active Suicidal Ideation with Specific Plan and Intent";
      } else if (!isSpecificPlan) {
        mostSevereIdeation.type = 4;
        mostSevereIdeation.description = "Active Suicidal Ideation with Some Intent to Act, without Specific Plan";
      } else if (!isActivNoPlan) {
        mostSevereIdeation.type = 3;
        mostSevereIdeation.description = "Active Suicidal Ideation with Any Methods (Not Plan) without Intent to Act";
      } else if (!isNonSpecific) {
        mostSevereIdeation.type = 2;
        mostSevereIdeation.description = "Non-Specific Active Suicidal Thoughts";
      } else if (!isWishToBeDead) {
        mostSevereIdeation.type = 1;
        mostSevereIdeation.description = "Wish to be Dead";
      }
      return mostSevereIdeation;
    },

    getMostSevereIdeationOfRecency() {
      const { isRecencyQuestionOne, isRecencyQuestionTow } = this;
      const nonSpecificPlan = this.activityQuestions[ACTIVE_SUICIDAL_NO_PLAN_BASELINE];
      const specificPlan = this.activityQuestions[INTENT_TO_ACT_BASELINE];
      const specificPlanAndIntent = this.activityQuestions[ACTIVE_SUICIDAL_SPECIFIC_PLAN_BASELINE];
      const isRecencyQuestionThree = !clinRoService.validateQuestionAnswer(nonSpecificPlan[2]);
      const isRecencyQuestionFour = !clinRoService.validateQuestionAnswer(specificPlan[2]);
      const isRecencyQuestionFive = !clinRoService.validateQuestionAnswer(specificPlanAndIntent[2]);
      const mostSevereIdeation = {
        type: null,
        description: null
      };
      if (!isRecencyQuestionFive) {
        mostSevereIdeation.type = 5;
        mostSevereIdeation.description = "Active Suicidal Ideation with Specific Plan and Intent";
      } else if (!isRecencyQuestionFour) {
        mostSevereIdeation.type = 4;
        mostSevereIdeation.description = "Active Suicidal Ideation with Some Intent to Act, without Specific Plan";
      } else if (!isRecencyQuestionThree) {
        mostSevereIdeation.type = 3;
        mostSevereIdeation.description = "Active Suicidal Ideation with Any Methods (Not Plan) without Intent to Act";
      } else if (!isRecencyQuestionTow) {
        mostSevereIdeation.type = 2;
        mostSevereIdeation.description = "Non-Specific Active Suicidal Thoughts";
      } else if (!isRecencyQuestionOne) {
        mostSevereIdeation.type = 1;
        mostSevereIdeation.description = "Wish to be Dead";
      }
      return mostSevereIdeation;
    },

    refresh() {}
  },
  data() {
    return {
      baseline: baseline,
      activityQuestions: [],
      disabledDates: {
        from: new Date()
      },
      globalElement: null,
      suicidalIdeationIn: '<p class="table-heading"><span class="d-block">Lifetime: Time </span> <span class="d-block">He/She Felt</span> <span class="d-block">Most Suicidal</span></p>',
      mostSeverLabel: '<span class="d-block"> Most </span>Severe',
      enterCodeLabel: "<span>Enter Code</span>"
    };
  },
  watch: {
    selectedId: {
      handler() {
        this.scrollToId();
      }
    },
    activityFormData: {
      handler(val) {
        this.activityQuestions = clinRoService.getActivityStructure(this.activityFormData.activity, this.$route.params.studyId);
      }
    }
  },
  mounted() {
    this.activityQuestions = clinRoService.getActivityStructure(this.activityFormData.activity, this.$route.params.studyId);
  },
  computed: {
    isMostRecentAttempt() {
      return false;
    },
    isMostLethalAttempt() {
      return false;
    },
    isMostFirstAttempt() {
      return false;
    },
    isWishToBeDead() {
      const wishToBeDeadQuestion = this.activityQuestions[WISH_TO_BE_DEAD_BASELINE];
      const isWishToBeDead = !clinRoService.validateQuestionAnswer(wishToBeDeadQuestion[1]);
      return isWishToBeDead;
    },

    isNonSpecific() {
      const nonSpecific = this.activityQuestions[NON_SPECIFIC_ACTIVE_BASELINE];
      const isNonSpecificQuestion = !clinRoService.validateQuestionAnswer(nonSpecific[1]);
      return isNonSpecificQuestion;
    },

    isActivNoPlan() {
      const noActivePlan = this.activityQuestions[ACTIVE_SUICIDAL_NO_PLAN_BASELINE];
      const noActivePlanQuestion = !clinRoService.validateQuestionAnswer(noActivePlan[1]);
      return noActivePlanQuestion;
    },

    isSpecificPlan() {
      const specificPlan = this.activityQuestions[INTENT_TO_ACT_BASELINE];
      const specificPlanQuestion = !clinRoService.validateQuestionAnswer(specificPlan[1]);
      return specificPlanQuestion;
    },

    isPlanAndIntent() {
      const planAndIntent = this.activityQuestions[ACTIVE_SUICIDAL_SPECIFIC_PLAN_BASELINE];
      const planAndIntentQuestion = !clinRoService.validateQuestionAnswer(planAndIntent[1]);
      return planAndIntentQuestion;
    },

    isRecencyQuestionOne() {
      const wishToBeDeadQuestion = this.activityQuestions[WISH_TO_BE_DEAD_BASELINE];
      return !clinRoService.validateQuestionAnswer(wishToBeDeadQuestion[2]);
    },

    isRecencyQuestionTow() {
      const nonSpecific = this.activityQuestions[NON_SPECIFIC_ACTIVE_BASELINE];
      return !clinRoService.validateQuestionAnswer(nonSpecific[2]);
    },

    isSuicidalIdeationRecency() {
      return false;
    },

    isSuicidalIdeation() {
      return false;
    },

    intensityOfIdeationSection() {
      return false;
    },

    isSuicidalBehaviorActualAttepts() {
      return false;
    },

    isSuicidalBehaviorActualAtteptsRecency() {
      return false;
    },

    isLifetimeInterruptedAttempt() {
      return false;
    },

    isRecencyInterruptedAttempt() {
      return false;
    },

    isRecencyAbortedAttempt() {
      return false;
    },

    isAbortedAttempt() {
      return false;
    },

    isPreparatoryActs() {
      return false;
    },

    isLifeTimeSuicidalBehavior() {
      return false;
    },

    isSubjectEngaged() {
      const suicidalBehavior = this.activityQuestions[ACTUAL_ATTEMPT_BASELINE];
      const isSubjectEngaged = !clinRoService.validateQuestionAnswer(suicidalBehavior[5]);
      return isSubjectEngaged;
    }
  }
};
</script>

<style scoped lang="scss">
.version-text {
  text-align: center;
  font-size: 15px;
  font-family: Times New Roman;
  color: #000000;
}
.text-col-8 {
  flex: 0 0 66.666667%;
  max-width: 66.666667%;
}
.boolean-question-text {
  position: absolute;
  left: -867px;
  white-space: nowrap;
  padding: 0px !important;
}
.txt-response-body {
  margin-top: 7rem;
}
.col.row {
  margin: 0 -15px !important;
}
.col-row {
  display: flex;
  flex: 0 0 100%;
  max-width: 100%;
}
.btnDisplay {
  top: 10px;
  right: 10px;
  position: absolute;
  border-color: #d3dfe4;
  background-color: #fff;
}
.btnDisplay:hover {
  color: #fff !important;
  background-color: #4c8ce4 !important;
}
.fieldCmp {
  color: #666669;
}
.form-components:last-of-type {
  padding-bottom: 15px;
}
.fieldCmp:hover + .btnDisplay,
.btnDisplay:hover {
  display: block;
}
.selected {
  background: #f9f9e0;
  border-color: #d3dfe4;
}
.custom-number-select-box {
  color: #000000;
  background-image: none;
  border: none;
  border-bottom: 1.5px solid #000;
  border-radius: 0px !important;
  width: 72% !important;
  background-color: initial;
  &:focus {
    border-radius: 0px !important;
    background-color: none;
    outline: 0;
    box-shadow: none !important;
  }
}
// .col-size-9 select.custom-number-select-box{
//     text-align-last: center;
// }
select.custom-number-select-box {
  text-align-last: center;
}
.col-align {
  padding: 0 !important;
}
select.custom-number-select-box {
  cursor: pointer;
}
.d-font {
  font-family: "Times New Roman", Times, serif !important;
  font-size: 16px;
  font-weight: 540px;
  color: #000000;
}
.col-size-1 {
  width: 79.500000009%;
  flex: 0 0 79.509%;
  max-width: 79.509%;
}
.col-size-2 {
  width: 11.499999995% !important;
  flex: 0 0 11.499% !important;
  max-width: 11.499% !important;
}
.col-size-3 {
  width: 8.999999996% !important;
  flex: 0 0 8.996% !important;
  max-width: 8.996% !important;
}
.col-size-4 {
  width: 80.000000008%;
  flex: 0 0 80.008% !important;
  max-width: 80.008% !important;
}
.col-size-9 {
  width: 10.2499999955% !important;
  flex: 0 0 10.2499999955% !important;
  max-width: 10.2499999955% !important;
}

.col-size-5 {
  width: 69.2500000135%;
  flex: 0 0 69.2500000135% !important;
  max-width: 69.2500000135% !important;
}
// .col-size-9{
//     flex: 0 0 11.11111110666667%;
//     max-width: 11.11111110666667%;
// }
.type_block {
  display: inline-block;
}
.select-size {
  width: 52px !important;
}
.input_box {
  border: none;
  background: transparent;
  width: 0px;
}
input.radio {
  width: 15px;
  height: 15px;
}
.text-line-height {
  line-height: 1.1;
}
.deterrents-dropdown select {
  padding-top: 0px;
  height: 30px;
}
.description-polish-lang {
  width: 50%;
  margin-left: 1rem;
  white-space: pre-line;
}

.description-common-lang {
  width: 50%;
  margin-left: 4rem;
  white-space: pre-line;
}
.padding-polish {
  padding: 10px 0 10px 0;
}
.padding-common {
  padding: 0 0 10px 0;
}

@media only screen and (min-width: 1504px) {
  .mediaclass {
    padding-right: 25px;
    padding-left: 15px;
  }
}

@media only screen and (min-width: 1280px) and (max-width: 1400px) {
  .col-size-9 {
    width: 12.2499999955% !important;
    flex: 0 0 12.2499999955% !important;
    max-width: 12.2499999955% !important;
  }
  .col-size-5 {
    width: 63.2500000135%;
    flex: 0 0 63.2500000135% !important;
    max-width: 63.2500000135% !important;
  }
  .col-size-3 {
    width: 10.999999996% !important;
    flex: 0 0 10.996% !important;
    max-width: 10.996% !important;
  }
  .col-size-2 {
    width: 13.499999995% !important;
    flex: 0 0 13.499% !important;
    max-width: 13.499% !important;
  }
  .col-size-1 {
    width: 75.500000009%;
    flex: 0 0 75.509%;
    max-width: 75.509%;
  }
  .description-polish-lang .qu-text-normal {
    font-size: 12px !important;
  }
}
</style>
